/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ChallengeType } from './ChallengeType';
import {
    ChallengeTypeFromJSON,
    ChallengeTypeFromJSONTyped,
    ChallengeTypeToJSON,
} from './ChallengeType';
import type { PasswordVerifyAttestationData } from './PasswordVerifyAttestationData';
import {
    PasswordVerifyAttestationDataFromJSON,
    PasswordVerifyAttestationDataFromJSONTyped,
    PasswordVerifyAttestationDataToJSON,
} from './PasswordVerifyAttestationData';

/**
 * 
 * @export
 * @interface PasswordVerifyAttestation
 */
export interface PasswordVerifyAttestation {
    /**
     * 
     * @type {string}
     * @memberof PasswordVerifyAttestation
     */
    challenge_id: string;
    /**
     * 
     * @type {ChallengeType}
     * @memberof PasswordVerifyAttestation
     */
    challenge_type: ChallengeType;
    /**
     * 
     * @type {PasswordVerifyAttestationData}
     * @memberof PasswordVerifyAttestation
     */
    data?: PasswordVerifyAttestationData;
}

/**
 * Check if a given object implements the PasswordVerifyAttestation interface.
 */
export function instanceOfPasswordVerifyAttestation(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "challenge_id" in value;
    isInstance = isInstance && "challenge_type" in value;

    return isInstance;
}

export function PasswordVerifyAttestationFromJSON(json: any): PasswordVerifyAttestation {
    return PasswordVerifyAttestationFromJSONTyped(json, false);
}

export function PasswordVerifyAttestationFromJSONTyped(json: any, ignoreDiscriminator: boolean): PasswordVerifyAttestation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'challenge_id': json['challenge_id'],
        'challenge_type': ChallengeTypeFromJSON(json['challenge_type']),
        'data': !exists(json, 'data') ? undefined : PasswordVerifyAttestationDataFromJSON(json['data']),
    };
}

export function PasswordVerifyAttestationToJSON(value?: PasswordVerifyAttestation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'challenge_id': value.challenge_id,
        'challenge_type': ChallengeTypeToJSON(value.challenge_type),
        'data': PasswordVerifyAttestationDataToJSON(value.data),
    };
}

